const customGematikLabels = window.gematikLabels || {};

const defaultRequirements = {
    SHALL: "MUSS",
    SHALL_NOT: "DARF NICHT",
    SHOULD: "SOLL",
    SHOULD_NOT: "SOLL NICHT",
    MAY: "KANN",
};

const defaultIg = {
    Download_Button_Image: "Bild herunterladen",
    Download_Button_SVG: "SVG herunterladen",
    FHIR_Parameter_Label: "Parameter",
    FHIR_Type_Label: "Type",
    FHIR_Expectation_Label: "Service Anforderung",
    FHIR_Documentation_Label: "Beschreibung",
};

const defaultApiDoc = {
    ContentTypes_Label: "Content Types",
    HeaderParams_Header: "HTTP Header-Parameter",
    Parameter_Label: "Parameter",
    Type_Label: "Type",
    Expectation_Label: "Service Anforderung",
    Description_Label: "Beschreibung",
    SearchParams_Header: "Such- und Steuerungsparameter",
    Documentation_Label: "Beschreibung",
    Response_Header: "Antwort Status-Codes",
    StatusCode_Label: "Code",
    ErrorCode_Label: "Error Code",
    Note_Label: "Bemerkungen",
    Response_Type: "Antwort",
    SearchInclude_And_RevInclude_Header: "Include und RevInclude",
    RequestExample_Header: "Beispielanfragen",
    ResponseExample_Header: "Beispielantworten",
    ErrorResponseExample_Header: "Beispielhafte Fehlerantworten",
    OperationId_Label: "OperationId",
    Copy_Button_Label: "Code kopieren",
    Copied_Button_Label: "Code wird kopiert",
};

const gematikLabels = {
    requirements: {
        ...defaultRequirements,
        ...(customGematikLabels.requirements || {}),
    },
    ig: {
        ...defaultIg,
        ...(customGematikLabels.ig || {}),
    },
    apiDoc: {
        ...defaultApiDoc,
        ...(customGematikLabels.apiDoc || {}),
    },
};

export default gematikLabels;
